const FETCH_ERROR = 'primaryEvent/FETCH_ERROR'
const FETCH_REQUESTED = 'primaryEvent/FETCH_REQUESTED'
const FETCH_SUCCESS = 'primaryEvent/FETCH_SUCCESS'

export default {
  FETCH_ERROR,
  FETCH_REQUESTED,
  FETCH_SUCCESS
}
